import { render } from "./AllRecurringInvoices.vue?vue&type=template&id=b4540064"
import script from "./AllRecurringInvoices.vue?vue&type=script&lang=js"
export * from "./AllRecurringInvoices.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__